import React, { useRef, useState, useEffect, useMemo } from 'react';
import { Button, classnames } from '@ygtechnologies/bygr-frontend-component-library';
import { faQuestion } from '@fortawesome/pro-light-svg-icons';
import theme from './Header.module.scss';
import { helpkitHelper } from '@/globals';
import { useHelpkitPopupObserver } from '@ygtechnologies/bygr-frontend-tools';
import { Trans, useLingui } from '@lingui/react/macro';
import { useIsMobile } from '@/utils/hooks';

export interface HelpkitButtonProps {}

export const HelpkitButton: React.FC<HelpkitButtonProps> = ({}) => {
    const [active, setActive] = useState(false);
    const loadObserver = useHelpkitPopupObserver(setActive, []);
    const init = useRef(false);
    const isMobile = useIsMobile();
    const { i18n } = useLingui();

    const locale = useMemo(() => i18n.locale, [i18n.locale]);

    return (
        <Button
            className={classnames(theme.iconButton, {
                [theme.active]: active,
            })}
            icon={faQuestion}
            onClick={() => {
                if (locale === 'de') {
                    helpkitHelper.setVersion('de');
                } else {
                    helpkitHelper.setVersion('');
                }
                helpkitHelper.togglePopover();
                loadObserver();
                if (!init.current) {
                    setActive(true);
                    init.current = true;
                }
            }}>
            {!isMobile && <Trans>Help</Trans>}
        </Button>
    );
};
